const state = () => ({
	functionQueue: []
});

const mutations = {
	addFunction(state, fn) {
		state.functionQueue.push(fn);
	},
	clearQueue(state) {
		state.functionQueue = [];
	}
};

const actions = {
	runIfConsented({ state, rootState, commit }, queueFunction = false) {
		if (typeof queueFunction === "function") {
			commit("addFunction", queueFunction);
		}

		if (
			rootState.consents.hasResponse ||
			!App.Eros.Config.general.enableFunctionConsentDelay ||
			App.urls.privacyPolicy === window.location.pathname
		) {
			state.functionQueue.forEach(fn => fn());
			commit("clearQueue");
		}
	}
};

export default {
	state,
	mutations,
	actions
};
